export default __webpack_public_path__ + "static/media/measure.bb771680.jpg";